import React, { Suspense } from 'react';
import { ActivityIndicator } from 'react-native';

import APIDocs from './components/Docs/API';
import Auth from './components/Auth';
import './config/i18n';
import ErrorBoundary from './components/ErrorBoundary';
import { ClientProvider, ClientContext } from './contexts/ClientContext';

import Main from './Main';

const App = () => {
  if ('/docs/api' === window.location.pathname) {
    return <APIDocs />;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<ActivityIndicator size="large" />}>
        <ClientProvider>
          <ClientContext.Consumer>
              {ctx => ctx.isLoggedIn ? (
                <ErrorBoundary>
                  {ctx.apolloClient ? (
                    <Main />
                  ) : (
                    <ActivityIndicator size="large" />
                  )}
                </ErrorBoundary>
              ) : (
                <Auth />
              )}
          </ClientContext.Consumer>
        </ClientProvider>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
